module.exports = __webpack_public_path__ + "static/media/no-video.4b2438d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-video.svg
// module id = 735
// module chunks = 0